import { Checkbox as CheckboxIcon, CheckboxSelected } from "grommet-icons"
import React from "react"
import styled from "styled-components"

interface IProps {
  checked: boolean
  onChange: (value: boolean) => void
  color?: string
}

const Wrapper = styled.div`
  display: inline-block;
`

const Checkbox = (props: IProps) => (
  <Wrapper onClick={() => props.onChange(!props.checked)}>
    {props.checked ? (
      <CheckboxSelected color={props.color} />
    ) : (
      <CheckboxIcon color={props.color} />
    )}
  </Wrapper>
)

Checkbox.defaultProps = {
  color: "#444",
}

export default Checkbox
